<template>
  <div class="main-content">
    <sideBarInvoiceModalModal v-if="invoiceModalData.open"
                              :modalData="invoiceModalData"
                              :onModalClose="closeModal"
    />

    <EmptyCardModal
      v-if="exportModalData"
      ref="modalExportComponent"
      :modalData="exportModalData"
      :onModalClose="() => exportModalData = null"
      :onModalAccept="() => exportStore()"
    >
      <slot>
        <div>
          <ExcelExportOptions ref="exportExcelOptions">
            <slot>
              <div class="form-group mb-0" v-if="$currentRole === 'admin'">
                <label><input type="checkbox" v-model="exportDetails.details">
                  экспортировать детали препарата
                </label>
              </div>
              <div class="form-group mb-0">
                <label><input type="checkbox" v-model="exportDetails.store_zero">
                  выгружать с остатком 0
                </label>
              </div>
              <div class="form-group mb-0">
                <label><input type="checkbox" v-model="exportDetails.store_remain_comparing">
                  сравнивать со складом МСК-дор
                </label>
              </div>
            </slot>
          </ExcelExportOptions>
        </div>
      </slot>
    </EmptyCardModal>

    <div class="card">
      <div class="card-body">
        <div>
          <Breadcrumbs :breadcrumbs="breadcrumbs"/>
        </div>
        <div>
          <div class="flex justify-content-between">
            <div>
              <div class="form-group mb-0">
                <input type="checkbox" id="ch_1" v-model="reduceStore">
                <label class="pl-2 pointer" for="ch_1">вычитать со склада препараты на руках у курьеров</label>
              </div>
              <div class="form-check">
                <input id="type_1" type="radio" value="1"
                       v-model="reduceType"
                       :disabled="!reduceStore"
                       class="form-check-input">
                <label for="type_1" class="form-check-label pointer">
                  вычитать на основе системы рюкзаков
                </label>
              </div>
              <div class="form-check">
                <input id="type_2" type="radio" value="2"
                       v-model="reduceType"
                       :disabled="!reduceStore"
                       class="form-check-input">
                <label for="type_2" class="form-check-label pointer">
                  вычитать на основе заявок
                </label>
              </div>
              <div class="form-group mt-2">
                <label for="">Номера накладных для игнорирования поступлений</label>
                <input placeholder="1111,2222,3333,...." type="text" v-model="ignoreInvoices" class="form-control">
              </div>
            </div>
            <div>
              <LoadingButton
                type="button"
                title="Показать остатки"
                className="btn btn-outline-info"
                :color="$constants.LOADING_COLOR"
                :loading="loading"
                :onClick="() => {this.getStoreStatus()}"
              />
            </div>
          </div>
          <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
          <div v-if="!loading">

            <div v-if="drugs && drugs.length" class="text-right">
              <button @click="exportStore(false)" class="btn btn-outline-info" type="button">Экспортировать в XLS
              </button>
            </div>
            <div v-if="invoices && invoices.length">
              <p>Вычитать из наличия на складе содержимое накладных:</p>
              <table class="table table-sm table-hover mt-1">
                <tbody>
                <tr>
                  <td width="40px">
                    <input type="checkbox" v-model="selectAllInvoices" @change="selectAll">
                  </td>
                  <td colspan="10">Выбрать все накладные</td>
                </tr>
                <tr v-for="invoice in invoices">
                  <td width="40px">
                    <input type="checkbox" v-model="selectedInvoices[invoice.id]">
                  </td>
                  <td width="110px">
                    <button @click="openInvoiceInModal(invoice.id)" class="btn btn-xs btn-info newWindowBtn">
                      <i class="icon-fa icon-fa-eye"></i>
                    </button>
                    {{ invoice.id }}
                  </td>
                  <td width="150px">{{ printDate(invoice.delivery_date, 'DD.MM.YYYY HH:mm') }}</td>
                  <td width="200px">{{ $AllStores[invoice.store_in].title }}</td>
                  <td>{{ invoice.comment }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <table class="table table-sm table-hover mt-1">
              <thead>
              <tr>
                <th></th>
                <th></th>
                <th>Препарат</th>
                <th></th>
                <th>Кол</th>
                <th>
                  <span class="pointer" @click="updateSorting('costPrice')">
                    <template v-if="sorting.costPrice === 'asc'">
                      <i class="icon-fa icon-fa-sort-amount-asc"></i>
                    </template>
                    <template v-else-if="sorting.costPrice === 'desc'">
                      <i class="icon-fa icon-fa-sort-amount-desc"></i>
                    </template>
                    <template v-else>
                    <i class="icon-fa icon-fa-sort"></i>
                    </template>
                  </span>
                  Себест.
                </th>
                <th>Сумма</th>
                <th>
                  <span class="pointer" @click="updateSorting('dateStamp')">
                    <template v-if="sorting.dateStamp === 'asc'">
                      <i class="icon-fa icon-fa-sort-amount-asc"></i>
                    </template>
                    <template v-else-if="sorting.dateStamp === 'desc'">
                      <i class="icon-fa icon-fa-sort-amount-desc"></i>
                    </template>
                    <template v-else>
                    <i class="icon-fa icon-fa-sort"></i>
                    </template>
                  </span>
                  Срок годн.
                </th>
                <th>Поступление</th>
                <th>Накладная</th>
              </tr>
              </thead>
              <tbody>
              <tr class="total_tr">
                <td colspan="4">Итого</td>
                <td>{{ totalData.drugs }}</td>
                <td></td>
                <td>{{ totalData.sum }}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr v-for="(drug, index) in sortedDrugs" v-if="updatedStore[drug.id]">
                <td>{{ index + 1 }}</td>
                <td>{{ drug.id }}</td>
                <td>{{ drug.title }}</td>
                <td>
                  <i v-if="drug.cool" class="icon icon-snowflake"/>
                </td>
                <td>{{ updatedStore[drug.id] }}</td>
                <td>{{ drug.costPrice }}</td>
                <td>{{
                    Math.round(drug.costPrice * updatedStore[drug.id] * 10) / 10
                  }}
                </td>
                <td>
                  <p v-for="vd in drug.validDates" v-if="vd.is_active">{{ printDate(vd.expire_date, 'DD.MM.YYYY') }}</p>
                </td>
                <td>{{ incomeInvoices[drug.id] && printDate(incomeInvoices[drug.id].delivery_date, 'DD.MM.YYYY') }}</td>
                <td align="right">{{ incomeInvoices[drug.id] && incomeInvoices[drug.id].id }}
                  <button v-if="incomeInvoices[drug.id]" @click="openInvoiceInModal(incomeInvoices[drug.id].id)"
                          class="btn btn-xs btn-info newWindowBtn">
                    <i class="icon-fa icon-fa-eye"></i>
                  </button>

                </td>
              </tr>
              <tr class="total_tr">
                <td colspan="4">Итого</td>
                <td>{{ totalData.drugs }}</td>
                <td></td>
                <td>{{ totalData.sum }}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="!loading && inBackPacks && inBackPacks.drugs && Object.keys(inBackPacks.drugs).length">
      <div class="card-header"><h6><strong>Препараты в рюкзаках</strong></h6></div>
      <div class="card-body">
        <table class="table table-sm table-hover mt-0">
          <thead>
          <tr>
            <th></th>
            <th>ID</th>
            <th>Препарат</th>
            <th>Курьер</th>
            <th>Заявки</th>
            <th>Кол</th>
            <th>Всего</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(drug, i) in getSortedDrugs(inBackPacks.drugNames)">
            <tr v-for="(back, runnerId, ii) in (inBackPacks.drugs[drug.id] || [])">
              <td v-if="ii === 0" :rowspan="Object.keys(inBackPacks.drugs[drug.id]).length">{{ i + 1 }}</td>
              <td v-if="ii === 0" :rowspan="Object.keys(inBackPacks.drugs[drug.id]).length">{{ drug.id }}</td>
              <td v-if="ii === 0" :rowspan="Object.keys(inBackPacks.drugs[drug.id]).length">{{ drug.title }}</td>
              <td>({{ runnerId }}) {{ runnerNames[runnerId].name }}</td>
              <td>
                <p class="mb-0" v-for="order in back.orders">
                  <button
                    @click="openOrderInModal(order)"
                    class="btn btn-xs btn-info newWindowBtn mr-1"
                  >
                    <i class="icon-fa icon-fa-eye"></i>
                  </button>
                  {{ order }}
                </p>
              </td>
              <td>{{ back.qty }}</td>
              <td v-if="ii === 0" :rowspan="Object.keys(inBackPacks.drugs[drug.id]).length">
                <strong>{{ getTotalQty(inBackPacks.drugs[drug.id], true) }}</strong></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card" v-if="!loading && drugsOnHands && Object.keys(drugsOnHands).length">
      <div class="card-header"><h6><strong>Препараты на руках у курьеров</strong></h6></div>
      <div class="card-body">
        <table class="table table-sm mt-0 table-hover">
          <thead>
          <tr>
            <th></th>
            <th>ID</th>
            <th>Препарат</th>
            <th>Курьер</th>
            <th>Кол</th>
            <th>Всего</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(drug, ii) in getSortedDrugs(Object.values(drugsNamesOnHangs))">
            <tr v-for="(qty, runnerId, i) in drugsOnHands[drug.id]">
              <td v-if="i === 0" :rowspan="Object.keys(drugsOnHands[drug.id]).length">{{ ii + 1 }}</td>
              <td v-if="i === 0" :rowspan="Object.keys(drugsOnHands[drug.id]).length">{{ drug.id }}</td>
              <td v-if="i === 0" :rowspan="Object.keys(drugsOnHands[drug.id]).length">{{ drug.title }}</td>
              <td>{{ runnerNames[runnerId] }}</td>
              <td>{{ qty }}</td>
              <td v-if="i === 0" :rowspan="Object.keys(drugsOnHands[drug.id]).length">
                <strong>{{ getTotalQty(drugsOnHands[drug.id]) }}</strong></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api'
import Breadcrumbs from '@/components/Breadcrumbs'
import LoadingButton from '@/components/buttons/LoadingButton'
import sideBarInvoiceModalModal from "@/components/modals/sideBarInvoiceModal"
import EmptyCardModal from "@/components/modals/EmptyCardModal.vue";
import ExcelExportOptions from "@/views/admin/invoices/components/ExcelExportOptions.vue";

export default {
  title: 'Наличие на складе',
  components: {
    Breadcrumbs,
    LoadingButton,
    sideBarInvoiceModalModal,
    EmptyCardModal,
    ExcelExportOptions,
  },
  computed: {
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  data() {
    return {
      exportModalData: null,
      ignoreInvoices: null,
      drugsIgnore: null,
      reduceStore: true,
      exportDetails: {
        details: false,
        store_zero: false,
        store_remain_comparing: false,
      },
      loading: false,
      exportLoading: false,
      reduceType: 2,
      drugs: [],
      inStore: {},
      sorting: {
        costPrice: false,
        dateStamp: false
      },
      updatedStore: {},
      invoices: [],
      drugsOnHands: {},
      drugsNamesOnHangs: {},
      selectedInvoices: {},
      incomeInvoices: {},
      selectAllInvoices: true,
      inBackPacks: [],
      runnerNames: {},
      totalData: {
        drugs: 0,
        sum: 0
      },
      invoiceModalData: {
        open: false
      },
      breadcrumbs: [
        {
          title: 'Все склады',
          routeName: 'BranchStores',
        },
      ],
      sortedDrugs: [],
    }
  },
  watch: {
    'selectedInvoices': {
      handler: function (val, oldVal) {
        this.updateInStore();
      },
      deep: true,
    },
  },
  mounted() {
    this.breadcrumbs.push({title: 'Склад ' + (this.$AllStores[this.$route.params.id] && this.$AllStores[this.$route.params.id].title)})
    if (+this.$route.params.id === 3) {
      this.reduceType = 1
    }
    this.getStoreStatus()
  },
  methods: {
    updateSorting(type) {
      Object.keys(this.sorting).forEach((k) => {
        if (k !== type) this.sorting[k] = false;
      })
      switch (this.sorting[type]) {
        case 'asc':
          this.sorting[type] = 'desc';
          this.sortedDrugs = _.orderBy([...this.drugs], type, 'desc')
          break;
        case 'desc':
          this.sorting[type] = false;
          this.sortedDrugs = this.getSortedDrugs();
          break;
        default:
          this.sorting[type] = 'asc';
          this.sortedDrugs = _.orderBy([...this.drugs], type, 'asc')
          break;
      }
    },
    openOrderInModal(orderId) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: orderId})
    },
    getTotalQty(backPack, object = false) {
      if (object) {
        return Object.values(backPack).reduce((a, b) => a + +b.qty, 0);
      } else {
        return Object.values(backPack).reduce((a, b) => a + +b, 0);
      }
    },
    selectAll(e) {
      Object.keys(this.selectedInvoices).forEach((iId) => {
        this.selectedInvoices[iId] = !!this.selectAllInvoices
      })
    },
    async exportStore(exportFile = true) {
      if (!exportFile) {
        this.exportModalData = {
          header: 'Настройки экспорта',
          acceptBtnText: 'Выгрузить',
        };
        return;
      }
      this.exportLoading = true;
      this.$refs.modalExportComponent.acceptBtnLoading = true;
      const exportOptions = {...this.exportDetails, ...this.$refs.exportExcelOptions.exportOptions};
      if (this.exportDetails.details) {
        exportOptions.sum = true;
        exportOptions.validDates = true;
      }
      const {data} = await api.post('/excel/exportCustomData',
        this.drugs.reduce((acc, d) => {
          let drug = {
            id: d.id,
            inStore: this.updatedStore[d.id],
            // ignoreInvoices: this.ignoreInvoices,
          };
          if (!this.exportDetails.store_zero && !drug.inStore) return acc;
          if (this.$refs.exportExcelOptions.exportOptions.finance) {
            drug.costPrice = this.incomeInvoices[d.id]?.cost_price;
          }
          if (this.exportDetails.details) {
            // drug.costPrice = d.costPrice;
            drug.sum = Math.round(d.costPrice * this.updatedStore[drug.id] * 10) / 10;
            drug.validDates = d.validDates.map((dd) => dd.expire_date).join(', ');
          }
          acc.drugs.push(drug)
          return acc;
        }, {drugs: [], exportOptions: exportOptions, store_id: this.$route.params.id})
      );
      // const {data} = await api.post('/excel/exportStoreStatus', {
      //   storeId: this.$route.params.id,
      //   removeInvoices: Object.keys(this.selectedInvoices)
      // })
      if (data.success) {
        window.location.href = data.link
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.exportLoading = false
      this.$refs.modalExportComponent.acceptBtnLoading = false;
      this.exportModalData = null;
    },
    getTotalFigures() {
      this.totalData = {drugs: 0, sum: 0}
      Object.keys(this.updatedStore).forEach((drugId) => {
        let qty = +this.updatedStore[drugId] || 0;
        // if (this.reduceStore) {
        //   if (this.drugsOnHands[drugId]) {
        //     qty -= +(Object.values(this.drugsOnHands[drugId]).reduce((a, b) => a + b, 0));
        //   }
        //   if (this.inBackPacks && this.inBackPacks.drugs && this.inBackPacks.drugs[drugId]) {
        //     qty -= +(Object.values(this.inBackPacks.drugs[drugId]).reduce((a, b) => a + +b.qty, 0));
        //   }
        // }
        // this.inStore[drugId] = qty
        this.totalData.drugs += qty
        this.totalData.sum += +(qty * (this.incomeInvoices[drugId] && this.incomeInvoices[drugId].cost_price || 0))
      })
      this.totalData.sum = Math.round(this.totalData.sum * 10) / 10;
      this.totalData.drugs = Math.round(this.totalData.drugs * 10) / 10;
    },
    updateInStore() {
      if (!Object.values(this.selectedInvoices).find((s) => s)) {
        this.updatedStore = {...this.inStore};
      } else {
        const inTransit = this.invoices.reduce((acc, i) => {
          if (this.selectedInvoices[i.id]) {
            i.details.forEach((d) => {
              if (!acc[d.drug_id]) acc[d.drug_id] = 0;
              acc[d.drug_id] += +d.qty;
            })
          }
          return acc;
        }, {})
        this.updatedStore = Object.keys(this.inStore).reduce((acc, drugId) => {
          acc[drugId] = this.inStore[drugId] - (inTransit[drugId] || 0);
          return acc;
        }, {})
      }
      this.getTotalFigures();
    },
    getSortedDrugs(drugs = null) {
      let allDrugs = drugs || [];
      if (this.drugs && this.drugs.length) {
        allDrugs = [...this.drugs];
      }
      return _.orderBy(allDrugs, 'title')
    },
    async getStoreStatus() {
      this.loading = true
      const {data} = await api.post('stores/status/' + this.$route.params.id, {
        reduce: this.reduceStore,
        ignoreInvoices: this.ignoreInvoices,
        reduceType: this.reduceType
      })
      if (!data.success) {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      } else {
        this.drugs = data.inStore.reduce((acc, s) => {
          let dateStamp = 0;
          if (s.valid_dates && s.valid_dates.length) {
            dateStamp = Math.min(...s.valid_dates.map(e => new Date(e.expire_date) / 10000));
          }
          const costPrice = data.incomeInvoices[s.drug.id] && Math.round(data.incomeInvoices[s.drug.id].cost_price * 10) / 10 || 0;
          acc.push({...s.drug, validDates: s.valid_dates, dateStamp: dateStamp, costPrice: costPrice})
          return acc
        }, [])

        this.invoices = data.invoices;
        this.incomeInvoices = data.incomeInvoices;
        this.drugsOnHands = data.drugsOnHands;
        this.runnerNames = data.runnerNames;
        this.inBackPacks = data.inBackPacks;
        this.drugsIgnore = data.drugsIgnore;
        this.drugsNamesOnHangs = data.drugsNamesOnHangs;

        this.inStore = data.inStore.reduce((acc, s) => {
          acc[s.drug.id] = s.qty
          if (this.reduceStore) {
            switch (+this.reduceType) {
              case 1:
                if (this.inBackPacks && this.inBackPacks.drugs && this.inBackPacks.drugs[s.drug.id]) {
                  acc[s.drug.id] -= +Object.values(this.inBackPacks.drugs[s.drug.id]).reduce((a, b) => a + b.qty, 0)
                }
                break;
              case 2:
                if (this.drugsOnHands[s.drug.id]) {
                  acc[s.drug.id] -= +Object.values(this.drugsOnHands[s.drug.id]).reduce((a, b) => a + b, 0)
                }
                break;
            }
          }
          return acc
        }, {})
        this.updatedStore = {...this.inStore};

        this.selectedInvoices = data.invoices.reduce((acc, i) => {
          acc[i.id] = true
          return acc
        }, {})
        this.sortedDrugs = this.getSortedDrugs();
      }
      this.getTotalFigures();
      this.loading = false
    },
    closeModal() {
      this.invoiceModalData.open = false;
    },
    async openInvoiceInModal(invoiceId) {
      this.invoiceModalData.invoiceId = invoiceId;
      this.invoiceModalData.open = true;
    },
  }
}
</script>

<style scoped>
.total_tr {
  background-color: #ffffc4;
  font-weight: 500;
}

.total_tr td {
  font-size: 14px;
}

table.table tbody td {
  vertical-align: middle;
  padding: 2px 5px;
}

.icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5BBFDE;
  margin: -3px 4px;
}

.pointer:hover {
  color: #00aff2;
}
</style>
